import { isWeb } from 'tamagui';

export * from '@tamagui/constants';

export const isNonMobileWeb = isWeb && window?.innerWidth >= 770;

export const HEADING_HORIZONTAL_PADDING = 8; // Offset button padding
export const CONTAINER_HORIZONTAL_PADDING = 16;
export const CONTENT_MAX_WIDTH = 480;

export const SCREEN_CONTAINER_HORIZONTAL_PADDING = 24;

export const GRADIENT_COLOR_TOP = '#DAEDE4';
export const GRADIENT_COLOR_BOTTOM = '#B4D0D8';
